import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { Theme } from "./Assets/theme/Theme";
import Admin from "./Components/Admin/Admin";
import CenterMessages from "./Components/Admin/Tools/CenterMessages/CenterMessages";
import CenterSettings from "./Components/Admin/Tools/CenterSettings/CenterSettings";
import IvrUserSkillsConfig from "./Components/Admin/Tools/IvrUserSkillsConfig/IvrUserSkillsConfig";
import PhoneNumberSettings from "./Components/Admin/Tools/PhoneNumberSettings/PhoneNumberSettings";
import { AppErrorHandler } from "./Components/ErrorHandling/ErrorHandler";
import ProtectedRoute from "./Components/Helpers/ProtectedRoute";
import Home from "./Components/Home/Home";
import UserContextProvider from "./Context/UserContext";
import { GemRoutes } from "./Routes";
import UserContextLoginExperience from "./V2/Login/Compositions/UserContextLoginExperience";
import UserContextOAuthLoginStep from "./V2/Login/Compositions/UserContextSsoLoginStep";
import UserContextSsoReauthenticator from "./V2/Login/Compositions/UserContextSsoReauthenticator";

const App: React.FC = () => (
  <main style={{ height: "100%", overflow: "hidden", backgroundColor: "#e9ebef" }}>
    <UserContextProvider>
      <ThemeProvider theme={Theme}>
        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={"en-US"}>
          <UserContextSsoReauthenticator />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<ProtectedRoute element={<Home />} />} />
              <Route path={`${GemRoutes.Admin}`} element={<ProtectedRoute requireAdmin element={<Admin />} />}>
                <Route path={`${GemRoutes.AdminCenterMessages}`} element={<CenterMessages />} />
                <Route path={`${GemRoutes.AdminCenters}`} element={<CenterSettings />} />
                <Route path={`${GemRoutes.AdminPhoneNumbers}`} element={<PhoneNumberSettings />} />
                <Route path={`${GemRoutes.AdminIvrUserSkills}`} element={<IvrUserSkillsConfig />} />
                <Route path={`${GemRoutes.Admin}/*`} element={<Navigate to={GemRoutes.Admin} />} />
              </Route>
              <Route
                path={GemRoutes.Login}
                element={<UserContextLoginExperience loginForm={UserContextOAuthLoginStep} />}
              />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </BrowserRouter>
        </LocalizationProvider>
        <AppErrorHandler />
        <ToastContainer autoClose={5000} position={"bottom-left"} />
      </ThemeProvider>
    </UserContextProvider>
  </main>
);

export default App;
